module.exports = __webpack_public_path__ + "static/media/london-4.8ca41bcc.svg";